// @ts-nocheck
import _ from "lodash";
import { put, select, takeEvery, takeLatest } from "redux-saga/effects";
import {
  getAPIData,
  getAPIDataV3,
  postAPIDataV3,
  putAPIDataV3,
} from "utils/api";
import {
  getItemFromLocalStorage,
  removeItemFromLocalStorage,
} from "utils/storage";
import * as tableColumnSagaActions from "../tableColumns/sagaActions";
import * as constants from "./constants";
import * as query from "./query";
import * as slice from "./reducer";
import * as ColumnSlice from "../tableColumns/reducer";
import * as sagaActions from "./sagaActions";
import * as selector from "./selector";
import { triggerNotification } from "organisms/notifications/sagaActions";
import { TFilter, TMetadata } from "./types";
import {
  getTableColumnsInfo,
  getColumnInfoByIndentifier,
} from "models/tableColumns/selector";
import { toggleLoader } from "models/loaders/sagaActions";
import { updateSearchQueries } from "organisms/searchFilter/reducer";
import { getDispatch, getState } from "reducers";
import { Events } from "molecules/ReactGrid/agGrid/utils/events";
import { GRID_EVENTS } from "molecules/ReactGrid/agGrid/constants";
import { getStatusQuery } from "pages/orders/query";
import { getOrdersSummaryInfo } from "pages/orders/sagaActions";
import { REQUESTS } from "utils/services/thetaretail/requests";
import { getWebAppSettings } from "models/user/selector";
import * as dynamicGridSagaActions from "models/dynamicGrid/sagaActions";
import {
  fetchGridMetaData,
  fetchTableColumnsAg,
} from "models/tableColumns/sagas";

type TPayload = {
  payload: {
    tableId: number;
    url?: string;
    filters?: TFilter;
    metaData?: TMetadata;
    dataProvider?: any;
  };
};

export const getData = (
  metaData,
  filters,
  isAdvancedSearch = true,
  exportParams
): Promise<any> => {
  // const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

  const search = {
    filter: query.createFiltersFromQueries(filters.search, filters.isView),
  };
  if (!metaData) {
    return Promise.resolve({});
  }

  let { dataProviderOptions = { type: "GET", version: 2 }, body } = metaData;
  if (body) {
    dataProviderOptions = {
      ...dataProviderOptions,
      body,
    };
  }
  //hard check for ag grid kits children - tableID 30
  const apiQuery =
    (Number(filters?.tableId) === 30 || Number(filters?.tableId) === 29) &&
    filters?.groupKeys?.length
      ? {
          ..._.omit(filters, ["search"]),
          isAdvancedSearch: Number(isAdvancedSearch),
          refresh: new Date().getTime().toString(),
        }
      : {
          ...filters,
          search: JSON.stringify(search),
          isAdvancedSearch: Number(isAdvancedSearch),
          refresh: new Date().getTime().toString(),
        };

  if (dataProviderOptions?.body?.filterGroups) {
    const filterGroups = {};
    _.map(_.keys(dataProviderOptions.body.filterGroups), (key) => {
      if (dataProviderOptions.body.filterGroups[key]) {
        filterGroups[key] = JSON.stringify({
          filter: query.createFiltersFromQueries(
            dataProviderOptions.body.filterGroups[key],
            filters.isView
          ),
        });
      }
      return undefined;
    });
    dataProviderOptions = {
      ...dataProviderOptions,
      body: {
        ...dataProviderOptions.body,
        filterGroups,
      },
    };
  }

  if (dataProviderOptions.type === "GET" && dataProviderOptions.version === 1) {
    return getAPIData(dataProviderOptions.url, {
      ...apiQuery,
      ...dataProviderOptions?.queryParams,
    })
      .then((response) => ({ response: response?.data }))
      .catch((error) => ({ error, isError: true }));
  }
  if (
    dataProviderOptions.type === "POST" &&
    dataProviderOptions.version === 2
  ) {
    return postAPIDataV3({
      service: dataProviderOptions.service,
      url: dataProviderOptions.url,
      body: {
        ...apiQuery,
        ...dataProviderOptions?.body,
        ...exportParams,
      },
      pathParams: dataProviderOptions?.pathParams,
      queryParams: dataProviderOptions?.queryParams,
    })
      .then((response) => ({ response: response?.data }))
      .catch((error) => ({ error, isError: true }));
  }

  return getAPIDataV3({
    service: dataProviderOptions.service,
    url: dataProviderOptions.url,
    queryParams: {
      ...apiQuery,
      ...dataProviderOptions?.queryParams,
      ...exportParams,
    },
    pathParams: dataProviderOptions?.pathParams,
  })
    .then((response) => ({ response: response?.data }))
    .catch((error) => ({ error, isError: true }));
};

const getStatusFilters = (tableId) => {
  if (Number(tableId) == 30) {
    // TODO: Critical
    return constants.OrderKitsFilter;
  }
  return constants.OrderStatusFilter;
};

export const rowDelete = async (payload, deleteActionFieldGroups) => {
  try {
    const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

    await postAPIDataV3({
      ...(payload?.isUploadGrid
        ? REQUESTS.POST.DELETE_UPLOAD_STAGING_ROW_DATA
        : REQUESTS.POST.DELETE_ROW_DATA),
      body: { ...payload, isView, fieldGroups: deleteActionFieldGroups },
    });
    return { isError: false };
  } catch (error) {
    return { error: error?.data || error, isError: true };
  }
};

export const updateColWidth = async (payload) => {
  try {
    await putAPIDataV3({ ...REQUESTS.PUT.UPDATE_COLUMN_CONFIG, body: payload });
    return { isError: false };
  } catch (error) {
    return { error: error?.data || error, isError: true };
  }
};
async function refreshGridData({ payload }) {
  const dispatch = getDispatch();
  const { tableId, isSoftRefresh = false } = payload;

  dispatch(tableColumnSagaActions.fetchTableColumnsAg(tableId));

  dispatch(
    slice.updateMetadata({
      tableId,
      isAppend: true,
      metaData: {
        refreshTimestamp: Date.now(),
        isSoftRefresh,
      },
    })
  );
}
export let summaryPromiseData = null;

export const setSummaryPromiseData = (data) => {
  summaryPromiseData = data;
};


export async function fetchGridData({ payload }: TPayload) {
  const state = getState();
  const dispatch = getDispatch();

  let {
    tableId,
    isAdvancedSearch,
    isAppend,
    extendedSearchFilters,
    pageNumber,
    sortDirection,
    itemsPerPage,
    sortField,
    multiSortColumns,
    isMultiSort,
    isView,
    isPivot,
  } = payload;

  try {
    dispatch(
      slice.updateLoader({ eventName: tableId.toString(), isLoading: true })
    );

dispatch(
    slice.updateMetadata({
      isAppend: true,
      tableId,
      metaData: {
        isPristine: true,
      },
    })
  );

    // ---- Build Filters ----
    let filters = selector.getGridFilters(state, tableId);
    const metaData = selector.getGridMetadata(state, tableId);
    if (extendedSearchFilters && filters) {
      filters.search = [...filters?.search, ...extendedSearchFilters];
    }

    // ---- Optional Pivot Enhancements ----
    let enhancedFilters = { ...filters };
    if (tableId === 115) {
      enhancedFilters = {
        ...filters,
        rowGroupCols: [
          { AliasName: "Item", QueryName: "Item" },
          { AliasName: "Warehouse", QueryName: "Warehouse" },
          { AliasName: "CustomerName", QueryName: "CustomerName" },
          { AliasName: "Genus", QueryName: "Genus" },
        ],
        isPivotMode: true,
        groupAggregation: [
          { QueryName: "sum(ItemOrderQty)", AliasName: "ItemOrderQty" },
        ],
      };
    }

    // ---- Define all API promises in parallel ----
    const promises: Promise<any>[] = [];

    // 1️⃣ Main grid data API
    
    const gridDataPromise = getData(
      payload?.body ? { ...metaData, body: payload.body } : metaData,
      {
        ...enhancedFilters,
        pageNumber: pageNumber || filters?.pageNumber || 1,
        itemsPerPage: itemsPerPage || filters?.itemsPerPage || 50,
        sortDirection: sortDirection || filters?.sortDirection,
        sortField: tableId===50&&sortField===undefined?undefined:sortField || filters?.sortField,
        multiSortColumns: multiSortColumns || filters?.multiSortColumns,
        isMultiSort: multiSortColumns?.length,
        isView,
        isPivot,
      },
      isAdvancedSearch
    );
    promises.push(gridDataPromise);

    // 2️⃣ Parallel summary info API (only for specific tables)
    if (query.isOrderPageId(tableId)) {
      const summaryPromise = dispatch(
        getOrdersSummaryInfo({ search: _.get(filters, "search"), tableId })
      );
      promises.push(summaryPromise);
    }

    // ---- Await all in parallel ----
    const [gridResponse, summaryResponse] = await Promise.all(promises);
    setSummaryPromiseData(summaryResponse);
    // ---- Handle Grid Response ----
    const { response = null, isError, error } = gridResponse;

    if (error?.message === "CANCELLED") return;
    if (isError) {
      dispatch(
        triggerNotification({
          message: !error?.data?.isSqlConnError
            ? error?.message || error?.data?.error?.message
            : "An error occurred while fetching data, please try again later.",
        })
      );
      return;
    }

    // ---- ⚙️ Update Component User Settings (restored logic)
    const updatedSettings = {
      tableId,
      component: query.getGridFilterName(tableId),
      metaData: {
        ...enhancedFilters,
        tableId,
        pageNumber: pageNumber || filters?.pageNumber || 1,
        itemsPerPage: itemsPerPage || filters?.itemsPerPage || 50,
        sortDirection: sortDirection || filters?.sortDirection,
        sortField: sortField || filters?.sortField,
        multiSortColumns: multiSortColumns || filters?.multiSortColumns,
        isMultiSort: isMultiSort || filters?.isMultiSort,
      },
    };

    if (updatedSettings.metaData.pageNumber === 1) {
      dispatch(sagaActions.updateComponentUserSettings(updatedSettings));
    }

    // ---- Map Data ----
    const data =
      response?.data?.map((d, index) => ({
        ...d,
        AppTableID: tableId,
        id: d[metaData?.selectRowKey],
        index,
      })) ?? [];

    // ---- Dispatch Grid Data ----
    dispatch(slice.updateGridData({ tableId, data, isAppend }));

    // ---- Optional: Handle Pivot Columns ----
    if (tableId === 115 && response?.columns) {
      const tableColumns = getTableColumnsInfo(state, tableId);
      const aggregationColumns = enhancedFilters?.groupAggregation?.map(
        (res) => res.AliasName
      );
      const updatedTableColumns = _.map(tableColumns, (t) => {
        const keyColumns = Object.keys(response?.columns);
        if (aggregationColumns.find((k) => k === t.AppColumnName)) {
          const parentCol = tableColumns.find((tc) =>
            keyColumns.find((k) => k === tc.AppColumnName)
          );
          const children = response?.columns[parentCol.AppColumnName].map(
            (node) => ({
              ...t,
              AppColumnAliasName: node,
              AppColumnName: `${node}|${t.AppColumnName}`,
              IsColumnEnabled: parentCol.IsColumnEnabled,
            })
          );
          return {
            ...parentCol,
            children: [
              { ...t, children, IsColumnEnabled: parentCol.IsColumnEnabled },
            ],
            IsColumnEnabled: parentCol.IsColumnEnabled,
          };
        }
        return t;
      });

      dispatch(
        ColumnSlice.updateTableColumns({
          tableId,
          tableColumns: updatedTableColumns,
        })
      );
    }

    // ---- Optionally process summary response ----
    if (summaryResponse && summaryResponse.payload) {
      // Handle summary data if needed
    }
    dispatch(
      slice.updateLoader({ eventName: tableId.toString(), isLoading: false })
    );
    return { data, columns: response?.columns };
  } catch (err) {
    dispatch(
      slice.updateLoader({ eventName: tableId.toString(), isLoading: false })
    );
    dispatch(
      triggerNotification({
        message: err.message || "An unexpected error occurred",
      })
    );
  }
}

export function ConvertToCSV(data) {
  let csv = data.map((row) => Object.values(row));
  csv?.unshift(Object.keys(data[0]));
  return csv.join("\r\n");
}

function* exportGridData({ payload }) {
  const { tableId, exportName, fieldGroups, extraFilters, selectColumnList } =
    payload;
  let filters = yield select((state) =>
    selector.getGridFilters(state, tableId)
  );
  let updatedFilters = _.cloneDeep(filters);
  if (extraFilters) {
    updatedFilters.search = [...updatedFilters.search, ...extraFilters];
  }
  let metaData = yield select((state) =>
    selector.getGridMetadata(state, tableId)
  );
  filters = { ...filters, fieldGroups };
  if (constants.exportTableIds.includes(tableId.toString())) {
    metaData = {
      ...metaData,
      dataProviderOptions: { type: "POST", version: 2 },
    };
    metaData.service = "grid";
  }
  yield put(
    toggleLoader({
      component: "download/" + payload.tableId,
      isLoading: true,
    })
  );
  metaData = { ...metaData, exportName, tableId, selectColumnList };
  const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

  try {
    const { isError, error } = yield getData(
      {
        ...metaData,
        dataProviderOptions: {
          ...metaData.dataProviderOptions,
          ...REQUESTS.POST.EXPORT_GRID_DATA,
          pathParams: { tableId },
        },
      },
      {
        ...updatedFilters,
        isView,
        pageNumber: updatedFilters?.pageNumber || 1,
      },
      true,
      { exportName, selectColumnList }
    );
    yield put(
      triggerNotification({
        message: isError
          ? error?.data?.message
          : "Please wait while we process your download",
        type: isError ? "error" : "success",
      })
    );
    if (isError) {
      yield put(
        toggleLoader({
          component: "download/" + payload.tableId,
          isLoading: false,
        })
      );
    }
  } catch (e) {
    console.log(e);
  }
}

async function downloadGridData({ payload }) {
  const dispatch = getDispatch();
  // yield put(
  dispatch(
    toggleLoader({
      component: "download/" + payload?.tableId,
      isLoading: false,
    })
  );
  // );
  const blobName = payload.link.split("download-grid/")[1];
  try {
    const response = await postAPIDataV3({
      service: REQUESTS.POST.GET_SAS_TOKEN.service,
      url: REQUESTS.POST.GET_SAS_TOKEN.url,
      body: {
        blobName,
      },
    });
    let link = document.createElement("a");
    link.setAttribute("href", response.data.blobUrl);
    link.setAttribute("target", "downloadIframe");
    link.style.visibility = "hidden";
    document.querySelector("#download-ref").appendChild(link);
    link.click();
    document.querySelector("#download-ref").removeChild(link);
    if (response.status === 200) {
      setTimeout(async () => {
        await putAPIDataV3({
          service: REQUESTS.PUT.DELETE_BLOB_DATA.service,
          url: REQUESTS.PUT.DELETE_BLOB_DATA.url,
          body: {
            url: blobName,
          },
        });
        // dispatch(triggerNotification({
        //   type: removebolbURl?.status === 200 ? 'success' : "error",
        //   autoClose: removebolbURl?.status === 200 ? 100 : 500,
        //   message: removebolbURl?.status === 200 ? `Data Downloaded Successfully` :
        //     `Data Download failed`
        // }))
      }, 2000);
    }
  } catch (error) {
    dispatch(
      triggerNotification({
        type: "error",
        autoClose: 500,
        message: `Data Download failed`,
      })
    );
  }
}

function* handleIsErpEnabled({ payload }) {
  try {
    yield put(toggleLoader({ component: "isLoadingErp", isLoading: false }));

    const { tableId } = payload;
    const isEnabled = yield select((state) =>
      selector.getERPStatus(state, tableId)
    );
    if (isEnabled !== undefined) {
      return;
    }
    const isErpEnabled = yield getAPIDataV3({
      service: REQUESTS.GET.GET_ERP_ENABLED.service,
      url: REQUESTS.GET.GET_ERP_ENABLED.url,
      queryParams: { tableId },
    })
      .then((response) => response?.data.isErpEnabled)
      .catch((err) => ({ isError: true, error: err }));

    if (isErpEnabled?.isError) {
      //TBD error handling;
      yield put(toggleLoader({ component: "isLoadingErp", isLoading: false }));

      yield put(
        triggerNotification({
          message: "Something went wrong, please try again later",
        })
      );
      return;
    }
    yield put(
      slice.updateMetadata({
        tableId,
        isAppend: true,
        metaData: {
          isErpEnabled,
        },
      })
    );
    yield put(toggleLoader({ component: "isLoadingErp", isLoading: false }));
  } catch (e) {}
}

function* updateGridFilters({ payload }: TPayload) {
  const {
    tableId,
    filters,
    isPaginated = true,
    pageNumber = 1,
    isStorageEnabled = true,
  } = payload;

  const filterData = yield select((state) =>
    selector.getGridFilters(state, tableId)
  );

  let updatedFilters =
    tableId === 115
      ? {
          ...filterData,
          ...filters,
          rowGroupCols: [
            {
              AliasName: "Item",
              QueryName: "Item",
            },
            {
              AliasName: "ItemDescription",
              QueryName: "ItemDescription",
            },
            {
              AliasName: "Genus",
              QueryName: "Genus",
            },
            {
              AliasName: "Size",
              QueryName: "Size",
            },
            {
              AliasName: "CustomerName",
              QueryName: "CustomerName",
            },
            {
              AliasName: "Warehouse",
              QueryName: "Warehouse",
            },
            {
              AliasName: "Current_Available_Qty",
              QueryName: "Current_Available_Qty",
            },
          ],
          isPivotMode: true,
          groupAggregation: [
            { QueryName: "sum(ItemOrderQty)", AliasName: "ItemOrderQty" },
          ],
        }
      : { ...filterData, ...filters };

  if (!updatedFilters.isMultiSort) {
    updatedFilters = _.omit(updatedFilters, [
      "isMultiSort",
      "multiSortColumns",
    ]);
  }

  yield put(
    slice.updateFilters({ tableId, filters: updatedFilters, pageNumber })
  );
}

function* updateGridMeta({ payload }: TPayload) {
  const { tableId, metaData, isAppend } = payload;
  yield put(slice.updateMetadata({ tableId, metaData, isAppend }));
}

function* loadGrid({ payload }: any) {
  const {
    tableId,
    dataProviderOptions,
    isPaginated = true,
    // isAdvancedSearch = false,
    isStorageEnabled = true,
    isReset,
    extendedSearchFilters,
    childTableSelectRowKey,
    selectRowKey,
    isUploadEnabled,
  } = payload;
  let metaData;
  let filters = yield select((state) =>
    selector.getGridFilters(state, tableId)
  );
  if (isStorageEnabled) {
    filters = isPaginated && getItemFromLocalStorage(tableId);
  }

  try {
    // if (!filters) {
    filters = { ..._.cloneDeep(constants.INITIAL_FILTER), ...filters };
    // }
    if (extendedSearchFilters) {
      filters.search = [...filters.search, ...extendedSearchFilters];
    }
    if (
      !_.find(filters.search, function (singleCreteria) {
        return singleCreteria?.criteria?.rowIdentifier === "OrderStatusID";
      }) &&
      query.ORDER_PAGE_ID.includes(tableId)
    ) {
      filters.search.push(getStatusFilters(tableId));
      filters.search = _.uniqWith(filters.search, _.isEqual);
    }

    if (isReset) {
      yield updateGridFilters({
        payload: {
          tableId,
          filters: { ...filters, pageNumber: 1 },
          isStorageEnabled,
        },
      });
    }

    metaData = {
      isStorageEnabled,
      selectRowKey,
      childTableSelectRowKey,
      isUploadEnabled,
      dataProviderOptions,
    };
  } catch (e) {}

  yield updateGridMeta({
    payload: { tableId, metaData: metaData ?? {}, isAppend: true },
  });
}

function* loadGridData({ payload }: any) {
  const { tableId, dataProvider } = payload;
  yield put(
    slice.updateLoader({ eventName: tableId.toString(), isLoading: true })
  );

  yield updateGridFilters({
    payload: { tableId, filters: constants.INITIAL_FILTER },
  });

  try {
    const { data, isError, error } = yield dataProvider();
    if (error?.message === "CANCELLED") {
      return;
    }
    if (isError) {
      // TODO: Handler Error
      yield put(
        triggerNotification({
          message:
            "An error occurred while fetching data, please try again later.",
        })
      );
      yield put(
        slice.updateLoader({ eventName: tableId.toString(), isLoading: false })
      );
      return;
    }
    yield put(slice.updateGridData({ tableId, data }));
    yield put(
      slice.updateLoader({ eventName: tableId.toString(), isLoading: false })
    );
  } catch (e) {
    return;
  }
}

function* updateGrid({ payload }: any) {
  const { tableId, filters, isAppend } = payload;

  const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

  let isStorageEnabled = yield select((state) =>
    selector.isTableStorageEnabled(state, tableId)
  );

  // try {
  yield updateGridFilters({
    payload: { tableId, filters, isStorageEnabled },
  });
  yield put(
    slice.updateMetadata({
      tableId,
      isAppend: true,
      metaData: {
        refreshTimestamp: Date.now(),
        isSoftRefresh: false,
      },
    })
  );
  // } catch (e) {}
  // yield fetchGridData({
  //   payload: filters,
  // });
}

function* loadMore({ payload: { tableId, isReset } }: any) {
  const { pageNumber = 1, ...filters } = yield select(
    (state) => selector.getGridFilters(state, tableId) || {}
  );
  const data: any = yield select((state) =>
    selector.getGridData(state, tableId)
  );
  if (
    !(data && data.length) ||
    pageNumber * filters.itemsPerPage > data?.[0]?.TotalRecordCount
  ) {
    return;
  }
  //   yield updateSelectedRows({
  //     payload: { tableId, selectedRowKeys: [], isSelectAll: false },
  //   });
  yield updateGridFilters({
    payload: {
      tableId,
      filters: { ...filters, pageNumber: isReset ? 1 : pageNumber + 1 },
      isPaginated: false,
      isStorageEnabled: false,
    },
  });

  if (isReset) {
    return;
  }
  yield fetchGridData({ payload: { tableId, isAppend: true } });
}

function* updateSelectedRows({ payload }: any) {
  const { tableId, selectedRowKeys, isSelectAll, rowGroup } = payload;
  yield put(
    slice.updateSelectedRows({
      tableId,
      data: { selectedRowKeys, isSelectAll, rowGroup },
    })
  );
}

function* updateGridRow({ payload }: any) {
  yield put(slice.updateGridRowData(payload));
}

function* updateTableCell({ payload }: any) {
  const { tableId, row, rowIdentifier, updatedValue } = payload;

  Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
    tableId,
    updatedRow: payload,
  });
}

function* onGridCleanUp({ payload }: any) {
  for (let index in payload.tableIds) {
    yield put(slice.cleanupGridData({ tableId: payload.tableIds[index] }));
    yield put(
      updateSearchQueries({
        tableId: payload.tableIds[index],
        searchQueries: null,
      })
    );
    removeItemFromLocalStorage(payload.tableIds[index]);
  }

  yield put(tableColumnSagaActions.cleanUpGrids(payload));
}

function* updateGridData({ payload }: any) {
  const { tableId, data } = payload;

  yield put(slice.updateGridData({ tableId, data }));
}

function* handleRowDelete({
  payload: { deleteActionFieldGroups, ...payload },
}: any) {
  const { tableId } = payload;
  const { isError, error } = yield rowDelete(payload, deleteActionFieldGroups);

  if (isError || error?.warning) {
    yield put(
      triggerNotification({
        message:
          error?.data?.message ||
          error?.message ||
          "Failed to delete row, Please try again later.",
      })
    );
    if (!error?.warning) {
      return;
    }
  }

  // Events.publish(GRID_EVENTS.DELETE_ROWS, {
  //   tableId,
  //   deletedRows: payload.deletedRows,
  // });
  yield put(
    sagaActions.handleRowDeleteSuccess({
      tableId,
    })
  );
  yield put(dynamicGridSagaActions.refreshGridData({ tableId }));
}

function* handleRowUpdateToggle({ payload }: any) {
  yield put(
    slice.handleRowUpdateToggle({
      ...payload,
    })
  );
}

async function handleRowGroupKeyUpdates(payload) {
 const {
      tableId,
      updatedValue,
      groupSearchParams,
      row,
      rowIdentifier,
      selectedRowKeyName,BulkUpdateJSON,
    } = payload;
  try {
    const dispatch = getDispatch();
    // Prepare request body
    const body =
      tableId === 115
        ? {
            IsGroupUpdate: true,
            updatedQty: updatedValue,
            tableId,
            [selectedRowKeyName]: row[selectedRowKeyName],
            Store: rowIdentifier.split("|")[0],
            isView: true,
          }
        : {
            searchParams: [
              ...groupSearchParams,
              { column: "OrderStatusID", value: 3, type: "number" },
            ],
            IsGroupUpdate: true,
            updatedQty: updatedValue,
            tableId,
            isView: true,
          };

    // API Call
    let response;
    try {
      response = await postAPIDataV3({
        service: REQUESTS.POST.POST_ORDER_BULK_EDIT.service,
        url: REQUESTS.POST.POST_ORDER_BULK_EDIT.url,
        body,
      });
    } catch (error) {
      response = { isError: true, error: error.data || error };
    }

    const { isError, error, data, status } = response;

    // Handle warnings
    if (data?.isWarning) {
      dispatch(triggerNotification({ message: data.message, type: "warning" }));
      return;
    }

    // Handle errors
    if (isError) {
      payload.updatedValue = {
        value: updatedValue,
        hasError: true,
        errorMessage:
          error?.message || "Failed to update. Please try again later.",
      };
      
      Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
        tableId,
        updatedRow: { ...payload, row, rowIdentifier },
      });
      return;
    }

    // Handle successful update
    if (status === 200) {
      // For tableId 115, API may return multiple updated rows; find matching row or merge all
      let updateRow = {};
      if (data?.updatedRows?.length) {
        if (tableId === 115 && data.updatedRows.length > 1) {
          // For Order Pivot, find the row that matches the current row's key fields
          // or merge all updated rows to get all updated fields including Current_Available_Qty
          const matchingRow = data.updatedRows.find((r) => {
            // Try to match by row key if available
            return r[selectedRowKeyName] === row[selectedRowKeyName];
          });
          if (matchingRow) {
            updateRow = matchingRow;
          } else {
            // If no exact match, merge all updated rows to capture all changes
            updateRow = data.updatedRows.reduce((acc, r) => ({ ...acc, ...r }), {});
          }
        } else {
          // Single row or non-115 table: use first row
          updateRow = data.updatedRows[0] || {};
        }
      }

      // Check for validation errors in API response
      if (tableId === 115 && (updateRow.StatusCode === 500 || updateRow.ErrorCode || updateRow.ErrorMessage)) {
        payload.updatedValue = {
          value: updatedValue,
          hasError: true,
          errorMessage:
            updateRow?.ErrorTrace || updateRow?.ErrorMessage || updateRow?.ErrorCode ||
            "Failed to update. Please try again later.",
        };
        
        Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
          tableId,
          updatedRow: { ...payload, row, rowIdentifier, isPivotMode: true },
        });
        return;
      }
      // For pivot mode (tableId 115), rowIdentifier is like "179|ItemOrderQty"
      // The API response might have the column as just "ItemOrderQty" or in a different format
      // Extract the actual column name from the pivot key
      let actualColumnName = rowIdentifier;
      if (tableId === 115 && rowIdentifier.includes('|')) {
        // For pivot columns, extract the column name after the pipe
        actualColumnName = rowIdentifier.split('|')[1];
      }
      
      // Try to get value from actual column name first, then fall back to pivot key
      // For pivot columns, the value is in the pivot key format like "179|ItemOrderQty"
      const cellValue = updateRow[rowIdentifier] ?? updateRow[actualColumnName] ?? updatedValue;
      
      payload.updatedValue = {
        value: cellValue,
        isUpdated: true,
      };

      dispatch(getOrdersSummaryInfo({ tableId }));

      Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
        tableId,
        updatedRow: { 
          ...payload, 
          row, 
          rowIdentifier, 
          updateRow, // Ensure updateRow is included with Current_Available_Qty
          isPivotMode: true, // Mark as pivot mode
        },
      });
    }
  } catch (err) {
    payload.updatedValue = {
      value: updatedValue,
      hasError: true,
      errorMessage: err?.message || "Failed to update. Please try again later.",
    };
    Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
      tableId,
      updatedRow: { ...payload, row, rowIdentifier },
    });
  }
}

async function handleRowKeyUpdates(payload) {
  const { tableId, row, metaData, rowIdentifier,BulkUpdateJSON } = payload;
  const isUploadGrid = metaData.isUploadEnabled;
  const dispatch = getDispatch();

  // if (Array.isArray(BulkUpdateJSON) && BulkUpdateJSON.length > 0) {
  //     dispatch(triggerNotification({ 
  //       title: "Reload Site?",
  //       description: "Changes you made may not be saved.",
  //       type: "info",
  //       notificationKey: "ORDER_UPDATE_IN_PROGRESS" // Use key to replace existing notification
  //     }));
  //   }

  let service = isUploadGrid
    ? REQUESTS.PUT.UPDATE_UPLOAD_ROW_DATA.service
    : REQUESTS.PUT.UPDATE_ROW_DATA.service;
  let url = isUploadGrid
    ? REQUESTS.PUT.UPDATE_UPLOAD_ROW_DATA.url
    : REQUESTS.PUT.UPDATE_ROW_DATA.url;
  let body = _.omit(payload, ["row", "isUploadGrid", "metaData"]);
  if (tableId === 62) {
    service = payload.metaData.dataProviderOptions.service;
    url = "column/alias";
    body = row;
  }

  Events.publish(GRID_EVENTS.UPDATE_ROWS, {
    tableId,
    updatedRow: {
      row: { ...row, [rowIdentifier]: payload.updatedValue },
      rowIdentifier,
    },
  });

  try {
    const { isError, error, data } = await putAPIDataV3({
      service,
      url,
      body,
    }).catch((error) => ({ isError: true, error: error?.data }));

    // Handle warnings
    if (data?.isWarning) {
      dispatch(triggerNotification({ message: data.message, type: "warning" }));
    }


    // Handle success updates
    if (data?.updatedRows?.length > 0) {
      // Get fresh metadata to avoid stale data issues after idle time
      const freshMetaData = selector.getGridMetadata(getState(), tableId) || metaData;
      const selectRowKey = freshMetaData?.selectRowKey || metaData?.selectRowKey;
      
      // Find the updated row - try multiple matching strategies for robustness
      let updateRow = data?.updatedRows?.find(
        (r) => row[selectRowKey] === r[selectRowKey]
      );
      
      // If not found, try matching by RowIdentifier from BulkUpdateJSON
      if (!updateRow && Array.isArray(BulkUpdateJSON) && BulkUpdateJSON.length > 0) {
        const rowIdentifierValue = BulkUpdateJSON[0]?.RowIdentifier;
        if (rowIdentifierValue) {
          updateRow = data?.updatedRows?.find(
            (r) => String(r[selectRowKey]) === String(rowIdentifierValue)
          );
        }
      }
      
      // If still not found, use first row (for bulk updates, all rows should have the same structure)
      if (!updateRow && data?.updatedRows?.length > 0) {
        updateRow = data?.updatedRows[0];
      }

      payload.updatedValue = {
        value: updateRow ? updateRow[rowIdentifier] : payload.updatedValue,
        isUpdated: true,
      };

      if (query.isOrderPageId(tableId)) {
        const getOrdersSummarybyTableId = tableId === 3 ? 23 : tableId;
        dispatch(getOrdersSummaryInfo({ tableId: getOrdersSummarybyTableId }));
      }

      // Update all rows from API response, not just the one that was edited
      // This ensures state updates work even if the row is not currently visible
      // For bulk updates, we need to update ALL columns that were edited, not just rowIdentifier
      const updatedRowsWithCellValue = data?.updatedRows?.map((r) => {
        // Check if this row matches any of the rows in BulkUpdateJSON
        const isEditedRow = Array.isArray(BulkUpdateJSON) 
          ? BulkUpdateJSON.some(bulkRow => String(bulkRow.RowIdentifier) === String(r[selectRowKey]))
          : (row[selectRowKey] === r[selectRowKey]);
        
        if (isEditedRow) {
          // For bulk updates, merge all updated columns from the API response
          // The API response should contain all columns that were updated
          const updatedRow = { ...r };
          
          // Update the specific rowIdentifier column if it exists
          if (r[rowIdentifier] !== undefined) {
            updatedRow[rowIdentifier] = {
              isUpdated: true,
              value: r[rowIdentifier],
            };
          }
          
          // Also check for other columns that might have been updated in bulk
          // Get all column keys from BulkUpdateJSON for this row
          if (Array.isArray(BulkUpdateJSON)) {
            const bulkRowForThisRow = BulkUpdateJSON.find(bulkRow => 
              String(bulkRow.RowIdentifier) === String(r[selectRowKey])
            );
            if (bulkRowForThisRow) {
              // Update all columns that were in the bulk update
              Object.keys(bulkRowForThisRow).forEach(key => {
                if (key !== 'RowIdentifier' && r[key] !== undefined) {
                  updatedRow[key] = {
                    isUpdated: true,
                    value: r[key],
                  };
                }
              });
            }
          }
          
          return updatedRow;
        }
        return r;
      });

      // Merge updateAvlQty with updatedRows if it exists, but only if the data is not already present
      let finalUpdatedRows = updatedRowsWithCellValue;
      if (Array.isArray(data?.updateAvlQty) && data.updateAvlQty.length > 0) {
        // Filter out updateAvlQty items that already exist in updatedRowsWithCellValue
        // Match by RowIdentifier from updateAvlQty with selectRowKey from updatedRows
        const uniqueUpdateAvlQty = data.updateAvlQty.filter(avlQty => {
          // Check if this RowIdentifier already exists in updatedRowsWithCellValue
          return !updatedRowsWithCellValue?.some(updatedRow => 
            String(updatedRow[selectRowKey]) === String(avlQty.RowIdentifier)
          );
        });
        
        // Only merge if there are unique items to add
        if (uniqueUpdateAvlQty.length > 0) {
          finalUpdatedRows = [...uniqueUpdateAvlQty, ...(updatedRowsWithCellValue || [])];
        }
      }

      Events.publish(GRID_EVENTS.UPDATE_GRID, {
        tableId,
        updatedRows: finalUpdatedRows,
        selectedRowKeyName: selectRowKey, // Add selectRowKey to help grid handler match rows
        updatedRow: payload, // Include payload for error handling in grid
        ...payload,
      });

if (Array.isArray(payload?.BulkUpdateJSON) && Array.isArray(data?.validationErrors)) {
  const validationErrorRowIdentifiers = data.validationErrors.map((item) => item.RowIdentifier);

  // Filter out rows that do not match with validation errors
  const mismatchedRows = payload.BulkUpdateJSON.filter(
    (item) => !validationErrorRowIdentifiers.includes(item.RowIdentifier)
  );
  if (mismatchedRows.length > 0) {
    localStorage.setItem("rowUpdateSuccess", JSON.stringify(mismatchedRows));
  }
}

      dispatch(
        slice.updateMultiRows({
          tableId,
          updatedRows: finalUpdatedRows || data?.updatedRows,
          selectRowKey: selectRowKey || metaData.selectRowKey,
          rowIdentifier,
        })
      );
      dispatch(
        slice.updateMetadata({
          isAppend: true,
          tableId,
          metaData: { isPristine: false },
        })
      );
      dispatch(
        sagaActions.handleRowUpdateSuccess({
          tableId,
          row,
          rowIdentifier,
        })
      );
    }

    // Handle validation errors
    if (isError || error?.warning || data?.validationErrors?.length > 0) {
      if (data?.validationErrors) {
        localStorage.setItem(
          "rowUpdateError",
          JSON.stringify(data?.validationErrors)
        );
      }

      // For bulk updates with validation errors, we need to handle each error row
      if (Array.isArray(BulkUpdateJSON) && BulkUpdateJSON.length > 0 && data?.validationErrors?.length > 0) {
        // Get fresh metadata for row matching
        const freshMetaData = selector.getGridMetadata(getState(), tableId) || metaData;
        const selectRowKey = freshMetaData?.selectRowKey || metaData?.selectRowKey;
        
        // Get current grid data to find original values before update
        const currentGridData = selector.getGridData(getState(), tableId) || [];
        
        // Create error rows for each validation error
        const errorRows = data.validationErrors.map((validationError) => {
          // Find the corresponding row in current grid data to get original value
          const originalRow = currentGridData.find(r => String(r[selectRowKey]) === String(validationError.RowIdentifier));
          const qtyKey = tableId === 1 ? "OrderQty" : "ItemOrderQty";
          
          // Get original value from grid data (before update was attempted)
          let originalValue = originalRow?.[rowIdentifier];
          if (originalValue && typeof originalValue === 'object' && originalValue.value !== undefined) {
            originalValue = originalValue.value;
          }
          
          return {
            [selectRowKey]: validationError.RowIdentifier,
            [rowIdentifier]: {
              value: originalValue, // Revert to original value from grid data
              hasError: true,
              errorMessage: validationError.ErrorMessage || "Failed to update, Please try again later.",
            },
          };
        });
        
        // Publish UPDATE_GRID with error rows so grid can revert them
        Events.publish(GRID_EVENTS.UPDATE_GRID, {
          tableId,
          updatedRows: errorRows,
          selectedRowKeyName: selectRowKey,
          updatedRow: payload,
          hasErrors: true,
          ...payload,
        });
      } else {
        // Single row error (non-bulk)
        const originalValue = row[rowIdentifier];
        const revertedValue = typeof originalValue === 'object' && originalValue?.value !== undefined
          ? originalValue.value
          : originalValue;

        payload.updatedValue = {
          value: revertedValue, // Revert to original value
          hasError: true,
          errorMessage:
            data?.validationErrors?.[0]?.ErrorMessage ||
            error?.message ||
            "Failed to update, Please try again later.",
        };

        Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
          tableId,
          updatedRow: payload,
          selectedRowKeyName: metaData?.selectRowKey,
          selectedRowKeyValue: row[metaData?.selectRowKey],
        });
      }
    }

    return;
  } catch (error) {
    // Handle unexpected errors
    payload.updatedValue = {
      value: payload.updatedValue,
      hasError: true,
      errorMessage: "An unexpected error occurred.",
    };
    Events.publish(GRID_EVENTS.UPDATE_GRID_CELL, {
      tableId,
      updatedRow: payload,
    });
  }
}

function* handleUpdateRowData({ payload }: any) {
  try {
    const {
      tableId,
      row,
      updatedValue,
      rowIdentifier,
      isInlineEdit,
      isGroupNode,
      isPivotMode,
      fieldGroups,
      pageNumber,BulkUpdateJSON
    } = payload;
const dispatch = getDispatch();
    if (!isInlineEdit) {
      return;
    }
    if (payload?.updatedValue?.hasError) {
      return;
    }

    const metaData = yield select((state) =>
      selector.getGridMetadata(state, tableId)
    );
    let tableFilters = yield select((state) =>
      selector.getGridFilters(state, tableId)
    );
    tableFilters = {
      ...tableFilters,
      search: JSON.stringify({
        filter: query.createFiltersFromQueries(tableFilters?.search ?? []),
      }),
    };
//  if (Array.isArray(BulkUpdateJSON) && BulkUpdateJSON.length > 0) {
//       dispatch(triggerNotification({ 
//         title: "Reload Site?",
//         description: "Changes you made may not be saved.",
//         type: "info",
//         notificationKey: "ORDER_UPDATE_IN_PROGRESS" // Use key to replace existing notification
//       }));
//     }

 const pageSize = tableFilters?.itemsPerPage ?? 50;
  
    let groupSearchParams = fieldGroups
      ? [
          {
            column: "OrderID",
            value: fieldGroups.OrderID,
            type: "number",
          },
        ]
      : [];
    if (tableFilters?.rowGroupCols?.length) {
      groupSearchParams = [
        ...groupSearchParams,
        ..._.filter(
          _.map(tableFilters.rowGroupCols, (col) => ({
            column: col.AliasName,
            value: row[col.AliasName],
            type: getColumnInfoByIndentifier(getState(), tableId, col.AliasName)
              ?.ColumnType,
          })),
          (c) => c.value
        ),
      ];
    }
    if (tableFilters?.groupKeys?.length) {
      groupSearchParams = [
        ...groupSearchParams,
        ..._.filter(
          _.map(
            tableFilters.rowGroupCols.slice(
              0,
              tableFilters.rowGroupCols.length - 1
            ),
            (col, index) => ({
              column: col.AliasName,
              value: tableFilters.groupKeys[index],
              type: getColumnInfoByIndentifier(
                getState(),
                tableId,
                col.AliasName
              )?.ColumnType,
            })
          ),
          (c) => c.value
        ),
      ];
    }
    if (tableFilters?.pivotColumns?.length) {
      groupSearchParams = [
        ...groupSearchParams,
        ..._.filter(
          _.map(tableFilters.pivotColumns, (col, index) => ({
            column: col.AliasName,
            value: rowIdentifier.split("|")[index],
            type: getColumnInfoByIndentifier(getState(), tableId, col.AliasName)
              ?.ColumnType,
          })),
          (c) => c.value
        ),
      ];
    }

    groupSearchParams = _.uniqBy(groupSearchParams, "column");
    if (tableId === 30 || tableId === 33) {
      return;
    }
    const paginationProps = !query.isRowUpdateNotificationEnabled(tableId)
          ? {
              ...tableFilters,
              pageNumber: 1,
              itemsPerPage: pageSize * tableFilters?.pageNumber,
              isMultiRowUpdate: true,
            }
          : {};
    if (
      (groupSearchParams?.length &&
        (isPivotMode || isGroupNode) &&
        isOrderPageId(tableId)) ||
      tableId === 115
    ) {
      yield handleRowGroupKeyUpdates(
        _.omit(
          {
            tableId,
            updatedValue,
            rowIdentifier,
            row,
            selectedRowKeyName: metaData.selectRowKey,
            selectedRowKeyValue: row[metaData.selectRowKey],
            ...([3, 4, 5, 6].includes(tableId) && {
              fieldGroups: { OrderID: row?.["OrderID"] }, ///////// TBD
            }),
            groupSearchParams,
           ...paginationProps,BulkUpdateJSON
          },
          ["sortField", "sortDirection"]
        )
      );
      return;
    } else {
      const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;
      yield handleRowKeyUpdates(
        _.omit(
          {
            tableId,
            updatedValue,
            rowIdentifier,
            row,
            isView,
            metaData,
            selectedRowKeyName: metaData.selectRowKey,
            selectedRowKeyValue: row[metaData.selectRowKey],
            ...([3, 4, 5, 6].includes(tableId) && {
              fieldGroups: { OrderID: row?.["OrderID"] }, ///////// TBD
            }),
            groupSearchParams,
            ...paginationProps,BulkUpdateJSON
          },
          ["sortField", "sortDirection"]
        )
      );
    }
  } catch (e) {
    console.log("update error", e);
  }
}

export async function handleUpdateColWidth({ payload }: any) {
  const { columnId, tableId, columnWidth } = payload;
  await updateColWidth({ tableId, columnId, columnWidth });
}

function* handleBulkRowDelete({ payload }) {
  const { tableId, isUploadGrid } = payload;
  const searchQuery = yield select((state) =>
    selector.getGridFilters(state, tableId)
  );
  const tableSelection = yield select((state) =>
    selector.getTableSelection(state, tableId)
  );
  const { isError, error } = yield rowDelete({
    tableId: tableId,
    rowIdentifier: tableSelection?.selectedRowKeys,
    isSelectAll: tableSelection?.isSelectAll,
    isUploadGrid,
    selectAllSearch: JSON.stringify({
      filter: query.createFiltersFromQueries(searchQuery?.search, true),
    }),
  });
  if (isError || error?.warning) {
    yield put(
      triggerNotification({
        message:
          error?.message ||
          "An error occurred while deleting sku exclusions, please try again later",
      })
    );
  }

  yield refreshGridData({
    payload: {
      tableId,
      isSoftRefresh: true,
    },
  });

  yield put(
    sagaActions.updateSelectedRows({
      tableId,
      isSelectAll: false,
      selectedRowKeys: [],
    })
  );
  yield put(tableColumnSagaActions.cleanUpGrids([tableId]));
}

async function updateUserGridMetaData({ payload }) {
  const dispatch = getDispatch();
  dispatch(
    slice.updateMetadata({
      tableId: payload.tableId,
      metaData: {},
      isAppend: true,
    })
  );

  await putAPIDataV3({
    service: REQUESTS.PUT.UPDATE_USER_GRID_DATA.service,
    url: REQUESTS.PUT.UPDATE_USER_GRID_DATA.url,
    body: {
      tableId: payload.tableId,
      attributes: {},
    },
    pathParams: {
      tableId: payload.tableId,
    },
  });
}

async function fetchUserGridData(payload) {
  dispatch(
    slice.updateGridData({ tableId, data: response?.data, isAppend: true })
  );
}

export async function fetchGridFiltersAsync({ payload }) {
  try {
    const { tableId, component, enableCache = false } = payload;

    if (enableCache && selector.getGridFilters(getState(), tableId)) {
      return;
    }

    const dispatch = getDispatch();
    dispatch(
      toggleLoader({
        component: "fetch_grid_filters/" + tableId,
        isLoading: true,
      })
    );
    let {
      data: { userSettings },
    } = await getAPIDataV3({
      service: REQUESTS.GET.GET_COMPONENT_USER_SETTINGS.service,
      url: REQUESTS.GET.GET_COMPONENT_USER_SETTINGS.url,
      queryParams: { component: query.getGridFilterName(tableId) },
      pathParams: {
        tableId,
      },
    });

    if (!userSettings?.ComponentMetaData?.search) {
      userSettings.ComponentMetaData = {
        ...userSettings.ComponentMetaData,
        search: [],
      };
    }
    if (
      [1, 2, 23, 30].includes(tableId) &&
      !userSettings?.ComponentMetaData?.search?.length &&
      !_.some(
        userSettings?.ComponentMetaData?.search,
        (s) => s.field === "OrderStatusID"
      )
    ) {
      userSettings?.ComponentMetaData.search.push(getStatusQuery("3", tableId));
    }

    if (tableId === 115) {
      const filters = userSettings?.ComponentMetaData;
      dispatch(
        slice.updateFilters({
          tableId,
          filters: {
            ...filters,
            search: filters.search.map((res) => ({
              ...res,
              query:
                res.criteria.rowIdentifier === "OrderStatusID"
                  ? "3"
                  : res.query,
            })),
            rowGroupCols: [
              {
                AliasName: "Item",
                QueryName: "Item",
              },
              {
                AliasName: "ItemDescription",
                QueryName: "ItemDescription",
              },
              {
                AliasName: "Genus",
                QueryName: "Genus",
              },
              {
                AliasName: "Size",
                QueryName: "Size",
              },
              { AliasName: "CustomerName", QueryName: "CustomerName" },
              { AliasName: "Warehouse", QueryName: "Warehouse" },
              {
                AliasName: "Current_Available_Qty",
                QueryName: "Current_Available_Qty",
              },
            ],
            isPivotMode: true,
            groupAggregation: [
              { QueryName: "sum(ItemOrderQty)", AliasName: "ItemOrderQty" },
            ],
          },
        })
      );
    } else {
      dispatch(
        slice.updateFilters({
          tableId,
          filters: userSettings?.ComponentMetaData,
        })
      );
    }

    dispatch(
      toggleLoader({
        component: "fetch_grid_filters/" + tableId,
        isLoading: false,
      })
    );
    if (userSettings) {
      dispatch(slice.updateComponentSettings(userSettings));
    }
  } catch (e) {
    console.log(e);
  }
}

async function fetchComponentUserSettings({ payload }) {
  try {
    const { tableId, component } = payload;
    const dispatch = getDispatch();
    dispatch(
      toggleLoader({
        component,
        isLoading: true,
      })
    );

    const {
      data: { userSettings },
    } = await getAPIDataV3({
      service: REQUESTS.GET.GET_COMPONENT_USER_SETTINGS.service,
      url: REQUESTS.GET.GET_COMPONENT_USER_SETTINGS.url,
      queryParams: { component },
      pathParams: {
        tableId,
      },
    });

    if (userSettings) {
      dispatch(slice.updateComponentSettings(userSettings));
    }
    dispatch(
      toggleLoader({
        component: component,
        isLoading: false,
      })
    );
  } catch (e) {
    console.log(e);
  }
}
export async function updateComponentUserSettings({ payload }) {
  try {
    const { tableId, component, metaData } = payload;
    const dispatch = getDispatch();
    dispatch(
      toggleLoader({
        component: component,
        isLoading: true,
      })
    );
    const results = await putAPIDataV3({
      service: REQUESTS.PUT.UPDATE_COMPONENT_USER_SETTINGS.service,
      url: REQUESTS.PUT.UPDATE_COMPONENT_USER_SETTINGS.url,
      pathParams: { tableId },
      body: { component, metaData },
    });

    dispatch(
      slice.updateComponentSettings({
        ...metaData,
        AppTableID: tableId,
        ComponentName: component,
      })
    );
    dispatch(
      toggleLoader({
        component: component,
        isLoading: false,
      })
    );
  } catch (e) {
    console.log(e);
  }
}

export async function handleSynchronousAgGridLoading(payload) {
  const { payload: pOptions } = payload;
  const dispatch = getDispatch();
  dispatch(
    toggleLoader({
      component: "agGridLoading/" + pOptions.tableId,
      isLoading: true,
    })
  );
  let gridMetaData = await fetchGridMetaData(payload);
  await fetchGridFiltersAsync(payload);

  await fetchTableColumnsAg({
    payload: {
      tableId: pOptions.tableId,
    },
  });
  if (gridMetaData?.ChildTableID) {
    await fetchGridMetaData({
      payload: {
        tableId: gridMetaData?.ChildTableID,
      },
    });
    await fetchTableColumnsAg({
      payload: {
        tableId: gridMetaData?.ChildTableID,
      },
    });
  }

  dispatch(
    toggleLoader({
      component: "agGridLoading/" + pOptions.tableId,
      isLoading: false,
    })
  );
}

export default function* rootSaga() {
  return [
    yield takeLatest(sagaActions.loadGrid, loadGrid),
    yield takeLatest(sagaActions.updateTableCell, updateTableCell),
    yield takeLatest(sagaActions.fetchGridFiltersAsync, fetchGridFiltersAsync),
    yield takeLatest(sagaActions.loadGridData, loadGridData),
    yield takeLatest(sagaActions.fetchGridData, fetchGridData),
    yield takeLatest(sagaActions.refreshGridData, refreshGridData),
    yield takeLatest(sagaActions.updateGridFilters, updateGridFilters),
    yield takeLatest(sagaActions.updateGridMeta, updateGridMeta),
    yield takeLatest(sagaActions.updateGrid, updateGrid),
    yield takeLatest(sagaActions.lazyLoad, loadMore),
    yield takeLatest(sagaActions.updateGridRow, updateGridRow),
    yield takeEvery(sagaActions.updateSelectedRows, updateSelectedRows),
    yield takeLatest(sagaActions.cleanUpGrids, onGridCleanUp),
    yield takeLatest(sagaActions.updateGridData, updateGridData),
    yield takeLatest(sagaActions.handleRowDelete, handleRowDelete),
    yield takeLatest(sagaActions.handleRowUpdateToggle, handleRowUpdateToggle),
    yield takeEvery(sagaActions.updateRowData, handleUpdateRowData),
    yield takeLatest(sagaActions.updateColumnWidth, handleUpdateColWidth),
    yield takeEvery(sagaActions.erpEnabled, handleIsErpEnabled),
    yield takeLatest(sagaActions.handleBulkRowDelete, handleBulkRowDelete),
    yield takeLatest(sagaActions.exportGridData, exportGridData),
    yield takeLatest(sagaActions.downloadGridData, downloadGridData),
    yield takeLatest(
      sagaActions.fetchComponentUserSettings,
      fetchComponentUserSettings
    ),
    yield takeLatest(
      sagaActions.updateComponentUserSettings,
      updateComponentUserSettings
    ),
    yield takeLatest(
      sagaActions.triggerSynchronousAgGridLoading,
      handleSynchronousAgGridLoading
    ),
  ];
}
